module.exports = __webpack_public_path__ + "static/media/pg_backpack_locked.f1b95b02.svg";